/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  mutation PlatformUpsertMutation($displayName: String, $copyright: String, $logo: String) {
    PlatformUpsert(displayName: $displayName, copyright: $copyright, logo: $logo) {
      displayName,
      copyright,
      logo,
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
